

function ContactMeBanner(){

    return (
        <>
            <div>
                <h1>Wanna link?</h1>
                <p>Checkout the below links, or shoot me an email!</p>
            </div>
        </>
    );

}

export default ContactMeBanner;